export const appendUrlParams = (
  base: string,
  params: Record<string, string | number | boolean | undefined | null>
) => {
  const urlParams = Object.entries(params)
    .map(([key, value]) => {
      if (value === undefined || value === null) {
        return null;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .filter(urlParam => !!urlParam)
    .join('&');

  const separator = base.includes('?') ? '&' : '?';

  return `${base}${separator}${urlParams}`;
};

export const parseUrlParams = (url: string): Record<string, string> => {
  const searchParams = url.match(/[^\\?]*\?(.*)/);
  if (!searchParams) {
    return {};
  }

  const params: Record<string, string> = {};
  searchParams[1].split('&').forEach(param => {
    const [rawKey, rawValue] = param.split('=');
    if (rawKey && rawValue) {
      const key = decodeURIComponent(rawKey);
      const value = decodeURIComponent(rawValue);
      params[key] = value;
    }
  });

  return params;
};
